import { ChevronLeft } from '../../../modules/design-system';
import { HeaderPillButton } from './HeaderPillButton';

export interface LobbyPillProps {
  onClick?: () => void;
  label?: string;
}

/**
 * "Back to lobby" pill — rendered only when the casino passed a `lobby_url`
 * at session launch. Same glass shell as {@link MyPacksPill}; icon-only
 * below 600px, chevron + label from 600px up.
 */
export function LobbyPill({ onClick, label = 'Lobby' }: LobbyPillProps) {
  return (
    <HeaderPillButton onClick={onClick} ariaLabel="Back to lobby" className="px-3 @[600px]:px-4">
      <ChevronLeft size={18} />
      <span className="hidden @[600px]:inline">{label}</span>
    </HeaderPillButton>
  );
}
